// import _ from "lodash";
import { onMounted, reactive } from "vue";
// api
import { getArticleList, reportData } from "@/api/common";
// config
import { raceTypeList, groupList, raceInfoList } from "@/config/race-video";
// hooks
import usePagination from "@/hooks/common/pagination";

export function useRaceVideo(pageSize = 6) {
  onMounted(() => {
    getArticleListApi();
  });
  const videoState = reactive({
    showPreview: false,
    videoData: [], // 视频列表数据
    curVideoItem: { resource: "" },
    raceTypeAct: raceTypeList[6].value, // 赛季类型
    groupAct: groupList[0].value, // 分组类型
    raceInfoAct: raceInfoList[0].value, // 赛季信息类型
    pageCfg: { forceEllipses: true },
    nextTxt: "",
    pageSize: pageSize,
    total: 0,
  });

  const { paginationState, paginationChange } = usePagination({
    currentPage: 1,
    pageSize: videoState.pageSize,
    total: 0,
    onChange: () => {
      getArticleListApi();
    },
  });

  /**
   * 接口
   */

  // 获取文章列表
  function getArticleListApi() {
    const codeVal = [
      videoState.raceTypeAct,
      videoState.groupAct,
      videoState.raceInfoAct,
    ].join("_");
    const params = {
      code: [codeVal],
      page: paginationState.currentPage,
      pageRows: videoState.pageSize,
    };
    getArticleList(params)
      .then((res) => {
        const data = res.data;
        videoState.videoData = data.list || [];
        videoState.total = data.total;
        paginationState.total = data.total;
        videoState.pageCount = Math.ceil(data.total / paginationState.pageSize);
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  // 点击视频item事件
  function clickVideoItemFct(itemVal) {
    videoState.curVideoItem = itemVal;
    videoState.showPreview = true;
    // 视频上报
    const params = {
      event_name: "click",
      click_id: itemVal.article_id,
      click_type: 10,
    };

    reportData(params).then(() => {});
  }

  // 点击go按钮分页
  function clickGoBtnFct(e) {
    e.stopPropagation();
    if (!videoState.nextTxt) {
      return;
    }

    // 获取总页码数
    const pageCount = Math.ceil(
      paginationState.total / paginationState.pageSize
    );

    // 当跳转的页码 > 总页码时
    if (parseInt(videoState.nextTxt) > pageCount) {
      videoState.nextTxt = pageCount;
      paginationState.currentPage = pageCount;
    }

    if (parseInt(videoState.nextTxt) === paginationState.currentPage) {
      return;
    }

    paginationState.currentPage = parseInt(videoState.nextTxt);
  }

  // 点击下一页分页
  function clickNextPageFct(e) {
    e.stopPropagation();
    videoState.nextTxt = "";

    // 获取总页码数
    const pageCount = Math.ceil(paginationState.total / videoState.pageSize);

    // 跳转到最后一页时，则禁止再次触发
    if (paginationState.currentPage >= pageCount) {
      return;
    }
    paginationState.currentPage = paginationState.currentPage + 1;
  }

  return {
    videoState,
    paginationState,
    paginationChange,
    clickVideoItemFct,
    clickGoBtnFct,
    clickNextPageFct,
    getArticleListApi,
  };
}
